<template>
    <b-col>
        <b-row class="archive-first-row">
            <b-col cols="12" sm="4">
                <div
                        class="archive-image"
                        :style="`background-image: url('${advert.img}');`"
                        v-b-toggle="`collapse_${advert.advert}`"
                >
                    <div class="detail-text-archive">
                        Bekijk details woning
                    </div>
                </div>
            </b-col>
            <b-col cols="12" sm="8" class="archive-block">
                <h1 v-if="advert.type === 'project'">
                    {{advert.title}}
                </h1>
                <h1 v-else>
                    {{advert.address.street}} {{advert.address.number}}
                </h1>
                <h2>
                    {{advert.address.city}}
                </h2>
                <hr/>
                <b-row class="flex-aligner">
                    <b-col cols="12" sm="7">
                        <i class="fad fax fa-ticket"></i>
                        <strong>
                            Uw positie
                        </strong>
                    </b-col>
                    <b-col cols="1" class="text-right">
                        <i class="fad fax fa-thermometer"></i>
                    </b-col>
                    <b-col cols="10" sm="4">
                        <input class="form-control" type="text" readonly :value="advert.position">
                    </b-col>
                    <!--<b-col cols="5">
                        <span v-if="advert.position > 20">
                            U maakt niet veel kans op deze woning
                        </span>
                        <span v-else-if="advert.position > 10">
                            U maakt kans op deze woning
                        </span>
                        <span v-else>
                            U maakt veel kans op deze woning
                        </span>
                    </div>-->
                </b-row>
                <b-row v-if="advert.bonus.length > 0">
                    <b-col cols="12" sm="6">
                        <i class="fad fax fa-award"></i>
                        <strong>
                            Toegepaste regelingen
                        </strong>
                    </b-col>
                    <b-col cols="12" sm="6">
                        <ul class="list-unstyled">
                            <li class="bonus-block" v-html="advert.bonus">
                            </li>
                        </ul>
                    </b-col>
                </b-row>
                <b-row v-if="showRemainingTime">
                    <b-col cols="12" sm="8">
                        <i class="fad fax fa-hourglass"></i>
                        <strong>
                            Looptijd van de advertentie
                        </strong>
                    </b-col>
                    <b-col ols="12" sm="4">
                        <input type="text" class="form-control" readonly :value="'nog ' + advert.runtime">
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="8">
                        <i class="fad fax fa-clock"></i>
                        <strong>
                            Advertentie {{showRemainingTime ? 'staat' : 'stond'}} op de site tot
                        </strong>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <input type="text" class="form-control" readonly :value="dutchDate(advert.periodEnd)">
                    </b-col>
                </b-row>
                <b-row v-if="advert.motivation !== undefined">
                    <b-col cols="12" sm="8">
                      <i class="fad fax fa-comment"></i>
                      <strong>
                        Uw motivatie
                      </strong>
                    </b-col>
                    <b-col cols="12" sm="4">
                      <span class="pointer" @click="openMotivation(advert.motivation)">Klik hier</span>
                    </b-col>
                </b-row>
                <b-row v-if="showLetters">
                    <b-col cols="12" sm="4">
                        <i class="fad fax fa-envelope"></i>
                        <strong>
                            Brieven
                        </strong>
                    </b-col>
                    <b-col cols="12" sm="8">
                        <ul class="list-unstyled">
                            <li v-if="advert.letters.length === 0">
                                <a class="letterlink">
                                    <i>Nog geen brieven ontvangen</i>
                                </a>
                            </li>
                            <li v-for="letter in advert.letters" :key="letter.id">
                                <a
                                        :href="`../pdfreader.cfm?id=${letter.id}`"
                                        target="_blank" :class="{'letterlink': true, 'letter-strike': letter.overwritten}"
                                        :title="letter.overwritten ? 'Deze brief is overschreven en niet meer geldig' : ''"
                                >
                                    {{letter.regDate.replace(' ', ' om ')}} -  {{letter.name}}
                                </a><br/>
                                <span v-html="letter.status.replace(':',':<br/>')"></span>
                                <span v-if="letter.daReaction">
                                    <br/><span class="pointer" @click="loadReaction(letter.daReactionText)">Klik hier voor uw gegevens</span>
                                </span>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
                <hr/>
            </b-col>
        </b-row>
        <HouseDetail :advert="advert"></HouseDetail>
        <b-row v-if="withdrawType === 'deleteReaction'">
            <b-col cols="12">
                <button class="btn btn-danger" @click="$emit('withdraw', advert)">
                    Mijn reactie verwijderen
                </button>
            </b-col>
        </b-row>
        <b-row v-if="withdrawType === 'withdrawReaction' && advert.canBeRedacted">
            <b-col cols="12">
                <button class="btn btn-danger" @click="$emit('withdraw', advert)">
                    Mijn reactie verwijderen
                </button>
            </b-col>
        </b-row>

        <b-modal
                :id="`da_${advert.advert}`"
                title="Uw digitale reactie"
                size="lg"
                ok-title="Sluiten"
                ok-variant="success"
                ok-only
        >
            <b-row>
                <b-col v-html="daReaction.replace(/\-xs/ig,'')">
                </b-col>
            </b-row>
        </b-modal>
        <b-modal
                v-if="advert.motivation !== undefined"
                :id="`mot_${advert.advert}`"
                title="Uw motivatie"
                size="lg"
                ok-title="Sluiten"
                ok-variant="success"
                :ok-only="withdrawType !== 'deleteReaction'"
                cancel-title="Aanpassen"
                cancel-variant="success"
                @cancel="changeMotivation(advert.advert)"
        >
            <b-row>
                <b-col v-html="motivation.replace(/\-xs/ig,'')">
                </b-col>
            </b-row>
        </b-modal>


    </b-col>


</template>

<script>
    import {reactionService} from "../../_services/reaction.service";
    import HouseDetail from '@/components/_reaction/houseDetail'
    import dateTransformers from '@/mixins/dateTransformers'

    export default {
        components: { HouseDetail },
        props: [
            'advert',
            'showLetters',
            'withdrawType',
            'showRemainingTime'
        ],
        data: () => {
            return {
                daReaction: '',
                motivation: ''
            }
        },
        mixins: [dateTransformers],
        name: 'houseBlurb',
        methods: {
            loadReaction(text) {
                this.daReaction = text
                this.$bvModal.show(`da_${this.advert.advert}`)
            },
            openMotivation(content) {
              this.motivation = content;
              this.$bvModal.show(`mot_${this.advert.advert}`)
            },
            changeMotivation(id) {
              window.parent.location = `/reageren/${id}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bonus-block {
        padding-top: 6px;
    }
</style>